<!--
 * @Descripttion: 
 * @version: 2.0.0
 * @Author: ck
 * @Date: 2019-09-23 15:00:54
 * @LastEditors: ck
 * @LastEditTime: 2019-10-17 11:08:34
 -->
<template>
  <section class="list-item p-t-b-100">
    <div class="container">
      <div class="bg-title text-center wow slideInUp">
        <h2 class="title">合作服务区</h2>
      </div>
    </div>

    <div class="container images">
      <swiper :options="swiperOption">
        <template v-for="item in dataList">
          <swiper-slide v-if="item.len == 15">
            <div class="row" v-for="(row, rowIndex) in item.data" :key="rowIndex">
              <div class="col-xs-3 reset-col-5 scalc-img" v-for="img in row" :key="img">
                <div class="img-box">
                  <img :src="require('@/assets/serverArea/area/'+img+'.jpg')" />
                  <!-- <img :src="'../../../assets/serverArea/area/'+img+'.jpg'" /> -->
                </div>
              </div>
            </div>
          </swiper-slide>
        </template>


      </swiper>
      <div class="swiper-pagination swiper-list-pagination"></div>
    </div>
  </section>
</template>
<script>
  //图片总数
  const IMG_COUNT = 86
  // 1- IMG_COUNT
  const IMG_COUNT_ORDER = Array.from({
    length: IMG_COUNT
  }, (v, k) => k + 1)
  //排除的id
  const excludeIds = [4, 14, 31, 44, 50, 67, 71]
  //切分
  const chunk = (arr, size) => Array.from({
    length: Math.ceil(arr.length / size)
  }, (v, i) => arr.slice(i * size, i * size + size));

  export default {
    data() {
      return {
        dataList: [],
        swiperOption: {
          // loop: true,
          effect: "fade",
          autoplay: {
            delay: 5000,
            disableOnInteraction: false
          },
          pagination: {
            el: '.swiper-pagination',
            clickable: true
          }
        }
      }
    },
    mounted() {
      this.initData()
    },
    methods: {
      initData() {
        let allImages = IMG_COUNT_ORDER.filter(item => !excludeIds.includes(item))
        let oneLevel = chunk(allImages, 15)
        let dataList = []
        oneLevel.forEach(item => {
          let row = {
            len: item.length,
            data: chunk(item, 5)
          }
          dataList.push(row)

        })
        this.dataList = dataList
        console.log(oneLevel, dataList)
      }
    },
  }
</script>
<style lang="scss" scoped>
  .list-item {
    background-size: cover;
    background-position: center;
    padding: 1rem 0rem;
    max-height: 8rem;

    .images {
      margin-top: 0.6rem;
      position: relative;
    }



    .reset-col-5 {
      width: 20%;
      padding-left: 0.02rem;
      padding-right: 0.02rem;
    }

    .img-box {
      max-width: 2.55rem;
      max-height: 1.41rem;
      margin-bottom: 0.04rem;
      overflow: hidden;

    }
  }

  @media screen and (max-width: 768px) {
    .list-item {
      padding: 0.4rem 0 0.1rem 0;

      .reset-col-5 {
        padding-left: 0.02rem;
        padding-right: 0.02rem;
      }

      .img-box {
        margin-bottom: 0.04rem;
      }

      .title {
        color: $color-primary;
      }

      .images {
        margin-top: 0;
      }
    }
  }
</style>